import { useEffect, useState } from "react";

import { publicEndpoints } from "../../../api";

// Local type definitions
interface NewsItem {
  id?: number | string;
  title?: string;
  content?: string;
  createdAt?: string;
  [key: string]: unknown;
}

const useNews = () => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [lastUpdate, setLastUpdate] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    publicEndpoints
      .getNews()
      .then(({ data }) => {
        setNews(data?.news || []);
        setLastUpdate(data?.updatedAt || undefined);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return {
    news,
    lastUpdate,
    isLoading,
  };
};

export default useNews;
